var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrowave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-microwave",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    x: 2,
    y: 4,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 7,
    x: 6,
    y: 8,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8v7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrowave);
export default __webpack_public_path__ + "static/media/microwave.129c72b0293588349035cc9267b28e3d.svg";
export { ForwardRef as ReactComponent };